import React, { useState, useEffect } from "react";
import { gql, useMutation, useQuery } from "@apollo/client";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";

const LOGGED_IN = gql`
  query LoggedIn {
    me {
      _id
      username
      token
      roles {
        name
      }
      features {
        name
      }
    }
  }
`;

const LOGIN = gql`
  mutation Login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      token
      _id
    }
  }
`;

const LOGIN_WITH_MICROSOFT = gql`
  mutation LoginWithMicrosoft($token: String!) {
    loginWithMicrosoft(token: $token) {
      token
      _id
    }
  }
`;

const UserContext = React.createContext([{}, () => {}]);

const UserProvider = (props) => {
  const { data: loggedInUser } = useQuery(LOGGED_IN, {
    fetchPolicy: "network-first",
  });
  const [loginMutation, { data }] = useMutation(LOGIN, {
    onCompleted: (data) => {
      localStorage.setItem("user-id", data.login._id);
      localStorage.setItem("token", data.login.token);

      window.groups = [
        {
          name: data.login._id,
          status: 1,
        },
      ];

      setUserToken(data.login.token);

      setLoggedIn(true);
    },
  });
  const [loginWithMicrosoftMutation, { data: data_microsoft }] = useMutation(
    LOGIN_WITH_MICROSOFT,
    {
      onCompleted: (data) => {
        localStorage.setItem("user-id", data.loginWithMicrosoft._id);
        localStorage.setItem("token", data.loginWithMicrosoft.token);

        window.groups = [
          {
            name: data.loginWithMicrosoft._id,
            status: 1,
          },
        ];

        setUserToken(data.loginWithMicrosoft.token);

        setLoggedIn(true);
      },
    }
  );
  const [loggedIn, setLoggedIn] = useState(false);
  const [user, setUser] = useState();
  const [signinError, setSigninError] = useState();
  const [userCollection, setUserCollection] = useState([]);
  const [token, setToken] = useState();
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();

  useEffect(() => {
    if (isAuthenticated) {
      const currentAccount = instance.getActiveAccount();

      if (currentAccount) {
        const accessTokenRequest = {
          scopes: ["User.Read"],
          account: currentAccount,
        };

        instance
          .acquireTokenSilent(accessTokenRequest)
          .then(function (accessTokenResponse) {
            // Acquire token silent success
            // Call API with token

            let accessToken = accessTokenResponse.idToken;
            loginWithMicrosoftMutation({ variables: { token: accessToken } });

            // Call your API with token
            // callApi(accessToken);
          })
          .catch(function (error) {
            //Acquire token silent failure, and send an interactive request
          });
      }
    }
  }, [instance, isAuthenticated, loginWithMicrosoftMutation, setUser]);

  useEffect(() => {
    if (loggedInUser?.me) {
      window.groups = [
        {
          name: loggedInUser.me._id,
          status: 1,
        },
      ];

      setUserToken(loggedInUser.me.token);

      setLoggedIn(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedInUser]);

  function login({ username, password }) {
    loginMutation({ variables: { username, password } });
  }

  function parseJwt(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  function setUserToken(token) {
    let new_user = parseJwt(token);

    window.random = "";

    setUser(new_user);
    setToken(token);
  }

  function signOut() {
    localStorage.removeItem("user-id");
    localStorage.removeItem("token");
    try {
      instance["browserStorage"].clear();
    } catch (err) {}

    window.location.href = window.location.origin;
  }

  return (
    <UserContext.Provider
      value={{
        user,
        loggedIn,
        userCollection,
        login,
        signinError,
        signOut,
        token,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export { UserContext, UserProvider };
